/* eslint-disable camelcase */
/* eslint-disable no-param-reassign */
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';

export default class FeedbackCircle extends Phaser.GameObjects.Container {
  constructor(scene, color, corrects, incorrects) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;
    this.color = color;
    this.correctFeedback = corrects;
    this.incorrectFeedback = incorrects;
    this.correctLen = this.correctFeedback.length;
    this.incorrectLen = this.incorrectFeedback.length;
    this.bgSize = 84;

    this.bg = ABCyaPhaser.Graphics.addCircle(-this.bgSize, -this.bgSize, this.bgSize, this.color, this, { x: 0, y: 0 }, true, true);
    this.lbl = ABCyaPhaser.Text.addText(0, 0, 24, '0xFFFFFF', FontKeys._asapbold, 'feedback', this, true).setWordWrapWidth(this.bgSize * 2 - 15);
  }

  showFeedback(correct) {
    let txt = null;
    let snd = null;

    if (correct) {
      const c_fb = this.correctFeedback[Phaser.Math.Between(0,this.correctLen - 1)];
      txt = ABCyaPhaser.Localization.instance.getLocalizedString(c_fb.text);
      snd = c_fb.audiofile;
    }
    else {
      const i_fb = this.incorrectFeedback[Phaser.Math.Between(0,this.incorrectLen - 1)];
      txt = ABCyaPhaser.Localization.instance.getLocalizedString(i_fb.text);
      snd = i_fb.audiofile;
    }
    this.lbl.text = txt;

    return snd;
  };
}